<script setup lang="ts">
import type { BooleanWidget } from '../../types/widget'

const props = defineProps<{ widget: BooleanWidget }>()
const emit = defineEmits<{ (e: 'update', value: boolean): void }>()

function toggle() {
  if (props.widget.disabled) return
  emit('update', !props.widget.value)
}
</script>

<template>
  <div class="np-widget np-widget--boolean nodrag" :title="props.widget.hint">
    <span
      class="np-checkbox"
      :class="{
        'is-checked': props.widget.value,
        'is-disabled': props.widget.disabled,
      }"
      role="checkbox"
      :aria-checked="props.widget.value"
      :tabindex="props.widget.disabled ? -1 : 0"
      @click.stop="toggle"
      @keydown.space.prevent="toggle"
      @keydown.enter.prevent="toggle"
      @pointerdown.stop
    >
      <svg viewBox="0 0 12 12" fill="none" aria-hidden="true">
        <path
          d="M2.5 6.2 L4.8 8.5 L9.5 3.6"
          stroke="currentColor"
          stroke-width="1.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
  </div>
</template>
